export const UI_IT = {
  header: {
    skipContent: "Salta al contenuto",
    openMenu: "Apri il menu",
    closeMenu: "Chiudi il menu",
    menuLabel: "Menu di navigazione",
    book: "Prenota",
    bookStay: "Prenota il tuo soggiorno",
    homeLabel: "Le dolci Dimore — home",
  },
  intro: {
    caption: "Bed & Breakfast · Borgo Virgilio",
    skip: "Salta l'introduzione",
  },
  marquee: [
    "Le dolci Dimore",
    "Bed & Breakfast",
    "Villa del Settecento",
    "Borgo Virgilio",
    "Mantova",
    "Ospitalità autentica",
  ],
  cta: {
    eyebrow: "Prenotazione diretta",
    defaultTitle: "Prenota direttamente, in modo semplice",
    defaultText:
      "Verifica disponibilità e tariffe aggiornate sul nostro booking engine ufficiale. Preferisci parlare con noi? Siamo a disposizione per telefono o email.",
    book: "Verifica disponibilità",
  },
  roomCard: { discover: "Scopri la camera", max: "max" },
  footer: {
    description:
      "Quattro camere con bagno privato in una villa del Settecento immersa nella campagna di Borgo Virgilio, a circa dieci minuti dal centro di Mantova.",
    explore: "Esplora",
    rooms: "Le camere",
    contacts: "Contatti",
    maxGuests: "ospiti",
    booking: "Prenota il tuo soggiorno",
    rights: "Gestione",
    privacy: "Privacy policy",
    cookie: "Cookie policy",
  },
  mobileCta: { call: "Chiama", book: "Prenota ora", whatsapp: "Scrivici su WhatsApp" },
  home: {
    seo: {
      title: "",
      description:
        "Bed and breakfast a Borgo Virgilio, a 10 minuti da Mantova: quattro camere con bagno privato in una villa del Settecento con giardino. Prenota direttamente.",
    },
    hero: {
      eyebrow: "Bed & Breakfast · Borgo Virgilio, Mantova",
      paragraph:
        "Una villa del Settecento nella campagna mantovana, a dieci minuti dal centro di Mantova. Quattro camere con bagno privato, giardino e un'accoglienza personale.",
      ctaRooms: "Scopri le camere",
      ctaBook: "Prenota il tuo soggiorno",
      alt: "La villa del Settecento de Le dolci Dimore vista dal giardino",
    },
    intro: {
      eyebrow: "La struttura",
      title: "Una casa con due secoli e mezzo di storia, aperta a chi viaggia",
      p1: "Le dolci Dimore è ospitata in una villa del Settecento nella campagna di Borgo Virgilio: quattro camere, un'area comune interna e un ampio giardino. Una piccola realtà indipendente, dove l'accoglienza è personale e il soggiorno segue un ritmo più lento, più tuo.",
      p2: "La posizione è la sua forza discreta: immersa nel verde, ma con il centro storico di Mantova a circa dieci minuti in auto e il casello A22 di Mantova Sud a pochi chilometri.",
      link: "Scopri la villa",
      alt: "Facciata della villa settecentesca de Le dolci Dimore",
    },
    video: {
      eyebrow: "Il video",
      title: "La villa dall'alto",
      text: "Un minuto di volo sopra Le dolci Dimore: l'ingresso della villa, le camere, il giardino e la campagna di Borgo Virgilio tutta intorno.",
      play: "Guarda il video della villa",
      videoLabel: "Video della villa de Le dolci Dimore ripresa dal drone",
    },
    rooms: {
      eyebrow: "Le camere",
      title: "Quattro camere, quattro modi di soggiornare",
      text: "Tutte al primo piano della villa, tutte con bagno privato. Cambia la capienza: da due a quattro ospiti.",
      link: "Confronta le camere",
    },
    services: {
      eyebrow: "Servizi",
      title: "Tutto l'essenziale, con la cura di casa",
      link: "Tutti i dettagli e le informazioni pratiche",
    },
    territory: {
      eyebrow: "Il territorio",
      title: "Mantova, i Gonzaga, il Mincio: un territorio che merita più di una notte",
      text: "Dalla reggia dei Gonzaga alla fioritura dei fiori di loto, dalle ciclabili d'argine ai borghi Patrimonio UNESCO: abbiamo raccolto in una guida i luoghi che vale la pena scoprire, con distanze reali dalla struttura.",
      cta: "Esplora la guida del territorio",
      alt: "Mantova riflessa sulle acque del Lago Superiore",
    },
    audience: {
      tourism: {
        eyebrow: "Per chi viaggia per turismo",
        title: "La base giusta per scoprire Mantova",
        text: "Dieci minuti dal centro storico, un quarto d'ora dal Parco del Mincio, mezz'ora da Sabbioneta: da qui si esplora la provincia senza cambiare alloggio, e la sera si torna nel silenzio del giardino.",
        alt: "Le sedute nel giardino de Le dolci Dimore",
      },
      business: {
        eyebrow: "Per chi viaggia per lavoro",
        title: "Comoda, silenziosa, senza attese",
        text: "A pochi chilometri dal casello A22 di Mantova Sud, con accesso da remoto assistito anche fuori orario e colazione in autonomia in camera: pensata per chi parte presto e torna tardi.",
        alt: "La scrivania della Camera 104 con TV e postazione colazione",
      },
    },
    practical: { eyebrow: "Informazioni essenziali" },
  },
  structure: {
    seo: {
      title: "La struttura: una villa del Settecento a Borgo Virgilio",
      description:
        "Le dolci Dimore è un B&B in una villa settecentesca nella campagna di Borgo Virgilio: quattro camere, area comune e giardino, a pochi minuti da Mantova.",
    },
    eyebrow: "La struttura",
    h1: "Una villa del Settecento, abitata con semplicità",
    lead: "Le dolci Dimore nasce in una villa settecentesca nella campagna di Borgo Virgilio, lungo la Strada Romana che collega Mantova al suo territorio. La casa conserva la misura delle dimore di campagna di un tempo: muri spessi, stanze luminose, un giardino che cambia con le stagioni.",
    s1: {
      title: "Quattro camere, niente di più",
      text: "Al primo piano della villa si trovano le quattro camere degli ospiti: la 101 e la 104 Standard, la 102 Superior e la 103 Deluxe, tutte con bagno privato. Averne poche è una scelta: ci permette di prenderci cura di ogni soggiorno senza la logica dei grandi numeri.",
      link: "Vedi le camere",
      alt: "Facciata principale della villa de Le dolci Dimore",
    },
    s2: {
      title: "Spazi condivisi e un giardino per rallentare",
      p1: "Oltre alle camere, gli ospiti condividono un'area comune interna e l'ampio giardino che circonda la villa. Sono gli spazi dove leggere qualche pagina al fresco, fare colazione con calma o semplicemente stare all'aperto dopo una giornata in giro per Mantova.",
      p2: "La nostra idea di accoglienza è concreta: ambienti puliti e ordinati, informazioni chiare prima dell'arrivo, disponibilità telefonica quando serve. Niente reception impersonale, niente formalità inutili.",
      alt: "L'area comune interna de Le dolci Dimore, con la porta a vetri aperta sul giardino",
    },
    s3: {
      title: "Nella campagna, ma mai lontani",
      text: "Borgo Virgilio confina con Mantova: dal cancello della villa al centro storico bastano circa dieci minuti in auto, e il casello A22 di Mantova Sud dista pochi chilometri. È la posizione giusta per chi vuole visitare la città senza dormire nel traffico, e per chi lavora in zona e cerca un rientro tranquillo.",
      link: "Scopri cosa vedere nei dintorni",
      alt: "Il giardino de Le dolci Dimore con i vialetti in ghiaia",
    },
  },
  roomsPage: {
    seo: {
      title: "Le camere del B&B vicino a Mantova",
      description:
        "Quattro camere con bagno privato a Borgo Virgilio: la 101 e la 104 Standard per 2 ospiti, la 102 Superior per 3 e la 103 Deluxe per 4. Verifica disponibilità e prenota.",
    },
    eyebrow: "Le camere",
    h1: "Scegli la camera giusta per il tuo soggiorno",
    lead: "Quattro camere al primo piano della villa, tutte con bagno privato. Cambiano la capienza e la configurazione dei letti: da qui puoi capire quale fa per te.",
    boxTitle: "Cosa trovi in ogni camera",
    boxItems: [
      "Bagno privato riservato alla camera",
      "Bollitore e macchina per il caffè",
      "Frigorifero con acqua, succo e yogurt",
      "Prodotti per la colazione in camera",
      "Ambiente al primo piano della villa",
      "Riordino giornaliero entro le 12:00",
    ],
    ctaTitle: "Non sai quale scegliere? Parliamone",
    ctaText: "Raccontaci come viaggi e in quanti siete: ti indicheremo la camera più adatta. Oppure verifica subito la disponibilità sul booking engine.",
  },
  roomDetail: {
    seoTitle: (name, type, cap) => `${name} — ${type} per ${cap} ospiti`,
    seoDescription: (name, beds, cap, excerpt) =>
      `${name} a Le dolci Dimore, B&B vicino a Mantova: ${beds}, bagno privato, fino a ${cap} ospiti. ${excerpt}`,
    breadcrumb: "Camere",
    theRoom: "La camera",
    servicesTitle: "Servizi della camera",
    summary: "In sintesi",
    maxCapacity: "Capienza massima:",
    people: "persone",
    privateBathroom: "Bagno privato in camera",
    recommendedFor: "Consigliata per:",
    book: "Verifica disponibilità e prenota",
    request: "Fai una richiesta",
    others: "Le altre camere",
    upTo: "fino a",
    guests: "ospiti",
    see: "Vedi",
    detailAlt: (name) => `Dettaglio della ${name}`,
  },
  servicesPage: {
    seo: {
      title: "Servizi e informazioni utili",
      description:
        "Tutto quello che devi sapere prima di prenotare Le dolci Dimore: bagno privato, colazione in camera, giardino, check-in 15:00–20:00 e check-out entro le 10:00.",
    },
    eyebrow: "Servizi e informazioni utili",
    h1: "Quello che trovi, spiegato senza giri di parole",
    lead: "Prima di prenotare è giusto sapere esattamente com'è organizzato il soggiorno. Qui trovi servizi, orari e modalità di accesso, così come sono davvero.",
    blocks: [
      {
        title: "Bagno privato in ogni camera",
        text: "Ognuna delle quattro camere ha il proprio bagno privato. Non ci sono servizi condivisi tra gli ospiti: la tua camera è uno spazio completo e riservato.",
      },
      {
        title: "La colazione, in autonomia",
        text: "Niente buffet e niente orari da rispettare: in camera trovi croissant, fette biscottate, cereali, biscotti, miele, marmellate e Nutella, con bollitore e macchina per il caffè. Nel frigorifero ci sono acqua, succo e yogurt. Ti organizzi come preferisci, anche se parti presto per lavoro.",
      },
      {
        title: "Il giardino",
        text: "L'ampio giardino che circonda la villa è a disposizione degli ospiti: il posto giusto per una pausa all'aperto, un libro, un caffè al fresco.",
      },
      {
        title: "L'area comune interna",
        text: "All'interno della villa c'è uno spazio comune a disposizione degli ospiti, con la porta a vetri che si apre direttamente sul giardino: pensato per un momento di relax fuori dalla camera.",
      },
      {
        title: "Le camere al primo piano",
        text: "Le camere si trovano al primo piano della villa, raggiungibili tramite le scale. Per esigenze di mobilità specifiche ti invitiamo a contattarci prima della prenotazione, così da valutare insieme la sistemazione più adatta.",
      },
      {
        title: "Accesso alla struttura",
        text: "Quando possibile, il check-in avviene di persona: ti accogliamo noi. In alternativa organizziamo l'accesso da remoto, con istruzioni chiare prima dell'arrivo e assistenza telefonica durante l'ingresso. In entrambi i casi, non resterai mai senza un riferimento.",
      },
    ],
    hours: [
      {
        title: "Check-in e check-out",
        textPre: "L'arrivo è previsto ",
        textStrong1: "dalle 15:00 alle 20:00",
        textMid: " e la camera va lasciata ",
        textStrong2: "entro le 10:00",
        textPost: ". Per orari diversi, contattaci in anticipo: faremo il possibile per venirti incontro.",
      },
      {
        title: "Riordino delle camere",
        text: "Le camere vengono riordinate secondo l'organizzazione della struttura, con le attività di pulizia concluse entro le ore 12:00.",
      },
      {
        title: "Una nota di trasparenza",
        text: "Non c'è una reception aperta 24 ore su 24: siamo una piccola struttura a conduzione diretta. Restiamo comunque raggiungibili telefonicamente per qualsiasi necessità durante il soggiorno.",
      },
    ],
  },
  territory: {
    seo: {
      title: "Il territorio: cosa vedere a Mantova e dintorni",
      description:
        "Guida del territorio per chi soggiorna a Le dolci Dimore: Mantova e i Gonzaga, Palazzo Ducale e Palazzo Te, il Parco del Mincio, i borghi e la cucina mantovana.",
    },
    eyebrow: "Il territorio",
    h1: "Mantova e la sua terra, raccontate da chi ci vive",
    lead: "Le dolci Dimore si trova in una posizione strategica: il centro storico di Mantova è a circa dieci minuti in auto, e da qui partono le strade verso il Mincio, i borghi della provincia e le tavole migliori della tradizione. Le distanze indicate sono tempi di percorrenza in auto, da verificare al momento del viaggio.",
    navLabel: "Categorie del territorio",
    credits:
      "Crediti fotografici del territorio: Carlo Pelagalli (skyline di Mantova e fiori di loto, CC BY-SA 3.0), Carlo Alberto Magagnini (Piazza Sordello e Palazzo Ducale, CC BY-SA 4.0), Michael S-R (tortelli di zucca, CC BY-SA 2.0), via Wikimedia Commons.",
    ctaTitle: "Una base comoda per esplorare tutto questo",
    ctaText: "Dormendo a Le dolci Dimore raggiungi Mantova in dieci minuti e tieni il resto del territorio a portata di giornata. Verifica la disponibilità delle camere.",
  },
  guide: {
    seo: {
      title: "La guida: cosa vedere e fare a Mantova",
      description:
        "Articoli e itinerari per organizzare il soggiorno a Mantova: cosa vedere in un giorno, un weekend tra i Gonzaga, il Parco del Mincio e la cucina mantovana.",
    },
    eyebrow: "La guida",
    h1: "Itinerari e consigli per il tuo soggiorno a Mantova",
    lead: "Articoli scritti con cura su cosa vedere, dove camminare e cosa mangiare a Mantova e dintorni. Li aggiorniamo nel tempo, con le informazioni che diamo anche ai nostri ospiti.",
    read: "Leggi l'articolo",
    minRead: "di lettura",
    credits:
      "Crediti fotografici degli articoli: Carlo Pelagalli e Carlo Alberto Magagnini (Mantova e il Mincio, CC BY-SA 3.0/4.0), Michael S-R (tortelli di zucca, CC BY-SA 2.0), via Wikimedia Commons.",
  },
  article: {
    back: "La guida",
    minRead: "di lettura",
    continueReading: "Continua a leggere",
    read: "Leggi",
    ctaTitle: "Trasforma l'itinerario in un soggiorno",
    ctaText: "Le dolci Dimore è la base ideale per seguire questi itinerari: camere con bagno privato a dieci minuti da Mantova, nella quiete della campagna.",
  },
  faq: {
    seo: {
      title: "Domande frequenti",
      description:
        "Le risposte alle domande più frequenti su Le dolci Dimore: posizione, camere, orari di check-in e check-out, colazione, accesso da remoto e prenotazioni.",
    },
    eyebrow: "Domande frequenti",
    h1: "Tutto quello che vuoi sapere prima di prenotare",
    introPre: "Se non trovi la risposta che cerchi, chiamaci al ",
    introPost: " o scrivici: rispondiamo volentieri.",
  },
  contact: {
    seo: {
      title: "Contatti e come arrivare",
      description:
        "Contatta Le dolci Dimore: Strada Romana 69/A, Borgo Virgilio (MN). Telefono +39 0376 1587002, email info@ledolcidimore.it. Modulo di richiesta e indicazioni stradali.",
    },
    eyebrow: "Contatti",
    h1: "Parliamone: siamo qui per aiutarti a organizzare il soggiorno",
    labels: {
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      whatsapp: "WhatsApp",
      whatsappNote: "Risposta rapida per richieste e arrivi.",
      hours: "Orari",
      hoursText: "Check-in dalle 15:00 alle 20:00 · Check-out entro le 10:00. Arrivi fuori orario? Contattaci in anticipo e organizziamo l'accesso da remoto.",
      arrival: "Come arrivare",
      arrivalText: "In auto: casello A22 di Mantova Sud, a pochi chilometri dalla struttura. Il centro storico di Mantova è a circa dieci minuti. Per informazioni sul parcheggio contattaci prima dell'arrivo.",
      directions: "Apri le indicazioni stradali",
    },
    map: {
      title: "Mappa: Le dolci Dimore, Strada Romana 69/A, Borgo Virgilio",
      load: "Carica la mappa interattiva",
      consent: "Cliccando carichi contenuti di Google Maps, soggetti alle relative informative privacy.",
    },
    form: {
      title: "Modulo di richiesta",
      intro: "Scrivici per informazioni, richieste particolari o per organizzare il tuo arrivo. Per disponibilità e prenotazioni immediate usa il ",
      introLink: "booking engine ufficiale",
      name: "Nome e cognome *",
      email: "Email *",
      phone: "Telefono",
      arrival: "Arrivo",
      departure: "Partenza",
      message: "Messaggio *",
      company: "Azienda",
      privacyPre: "Ho letto l'",
      privacyLink: "informativa privacy",
      privacyPost: " e acconsento al trattamento dei dati per rispondere alla mia richiesta. *",
      submit: "Invia la richiesta",
      sending: "Invio in corso…",
      errName: "Inserisci il tuo nome",
      errEmail: "Inserisci un indirizzo email valido",
      errMessage: "Scrivi un messaggio di almeno 10 caratteri",
      errPrivacy: "Devi accettare l'informativa privacy",
      toastOk: "Richiesta inviata. Ti risponderemo al più presto.",
      toastErr: "Non siamo riusciti a inviare la richiesta. Riprova o chiamaci al ",
      successTitle: "Richiesta inviata",
      successTextPre: "Grazie per averci scritto. Ti risponderemo al più presto all'indirizzo email che hai indicato. Per urgenze puoi chiamarci al ",
      newRequest: "Invia un'altra richiesta",
    },
  },
  privacy: {
    seo: {
      title: "Privacy policy",
      description: "Informativa sul trattamento dei dati personali di Le dolci Dimore, gestita da Carmadue9 Srl.",
    },
    eyebrow: "Documento in aggiornamento con il consulente privacy",
    h1: "Privacy policy",
    updated: "Ultimo aggiornamento: luglio 2026",
    sections: [
      {
        title: "Titolare del trattamento",
        text: "Il titolare del trattamento dei dati personali è Carmadue9 Srl, gestore della struttura Le dolci Dimore, Strada Romana 69/A, 46034 Borgo Virgilio (MN). Per qualsiasi informazione puoi scrivere a info@ledolcidimore.it o chiamare il numero +39 0376 1587002.",
      },
      {
        title: "Dati raccolti tramite il modulo di contatto",
        text: "Quando compili il modulo di richiesta informazioni raccogliamo nome, indirizzo email, numero di telefono (facoltativo), eventuali date del soggiorno e il contenuto del messaggio. Questi dati vengono utilizzati esclusivamente per rispondere alla tua richiesta e non vengono ceduti a terzi né utilizzati per finalità di marketing senza il tuo consenso.",
      },
      {
        title: "Prenotazioni tramite Beddy",
        text: "Le prenotazioni avvengono sul booking engine esterno Beddy (ledolcidimore.beddy.io). I dati inseriti in fase di prenotazione sono trattati da Beddy secondo la propria informativa privacy, che ti invitiamo a consultare sul sito del fornitore.",
      },
      {
        title: "Dati di navigazione e strumenti di analisi",
        text: "Il sito può raccogliere dati tecnici di navigazione necessari al funzionamento e alla sicurezza. L'eventuale integrazione di strumenti di analisi statistica avverrà nel rispetto della normativa e previa acquisizione del consenso ove richiesto.",
      },
      {
        title: "Diritti dell'interessato",
        text: "Ai sensi del Regolamento (UE) 2016/679 (GDPR) puoi richiedere in qualsiasi momento l'accesso, la rettifica, la cancellazione o la limitazione del trattamento dei tuoi dati personali, scrivendo a info@ledolcidimore.it.",
      },
    ],
  },
  cookie: {
    seo: {
      title: "Cookie policy",
      description: "Informativa sui cookie utilizzati dal sito di Le dolci Dimore.",
    },
    eyebrow: "Documento in aggiornamento con il consulente privacy",
    h1: "Cookie policy",
    updated: "Ultimo aggiornamento: luglio 2026",
    sections: [
      {
        title: "Cosa sono i cookie",
        text: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.",
      },
      {
        title: "Cookie utilizzati da questo sito",
        text: "Questo sito utilizza cookie tecnici, necessari al funzionamento delle pagine e delle preferenze di navigazione, che non richiedono il consenso dell'utente. La mappa di Google Maps nella pagina Contatti viene caricata solo dopo un'azione volontaria (clic sul riquadro della mappa): fino a quel momento nessun cookie di terze parti legato alla mappa viene installato.",
      },
      {
        title: "Cookie di terze parti",
        text: "L'eventuale futura attivazione di strumenti di analisi o di contenuti di terze parti avverrà previa acquisizione del consenso tramite l'apposito pannello, con possibilità di modificare le preferenze in qualsiasi momento.",
      },
      {
        title: "Come gestire i cookie dal browser",
        text: "Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser. La disattivazione dei cookie tecnici può compromettere il corretto funzionamento di alcune parti del sito.",
      },
      {
        title: "Contatti",
        text: "Per domande relative a questa cookie policy puoi scrivere a info@ledolcidimore.it.",
      },
    ],
  },
  notFound: {
    seo: { title: "Pagina non trovata", description: "La pagina che cerchi non esiste o è stata spostata." },
    eyebrow: "Errore 404",
    h1: "Questa pagina non c'è, ma la campagna sì",
    text: "Il contenuto che cercavi potrebbe essere stato spostato. Torna alla homepage o scopri le camere de Le dolci Dimore.",
    home: "Torna alla home",
    rooms: "Vedi le camere",
  },
};
